import { useTenant } from "../context/TenantContext";
import { colors, fontSizes, radii } from "../styles/theme";

const ROLE_BADGE: Record<string, { label: string; color: string }> = {
  owner:  { label: "owner",  color: colors.goldPrimary },
  admin:  { label: "admin",  color: colors.green },
  member: { label: "member", color: colors.textMuted },
};

export function OrgSwitcher() {
  const { tenant, loading } = useTenant();
  if (loading || !tenant) return null;

  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 6, flexShrink: 0,
      padding: "4px 10px",
      background: "rgba(247,220,111,0.06)",
      border: "1px solid rgba(247,220,111,0.15)",
      borderRadius: radii.pill,
      maxWidth: 160,
    }}>
      <span style={{
        fontSize: fontSizes.xs, fontWeight: 700, color: colors.textBody,
        overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
      }}>
        {tenant.name}
      </span>
    </div>
  );
}

export function OrgRoleBadge({ role }: { role: string }) {
  const badge = ROLE_BADGE[role] ?? { label: role, color: colors.textMuted };
  return (
    <span style={{
      fontSize: "0.65rem", fontWeight: 700, letterSpacing: "0.05em",
      textTransform: "uppercase", color: badge.color,
      background: `${badge.color}18`,
      border: `1px solid ${badge.color}44`,
      borderRadius: radii.pill,
      padding: "2px 7px", flexShrink: 0,
    }}>
      {badge.label}
    </span>
  );
}
